import SpeedoMeterComponent from "./Speedometer/Speedometer";
import SpeedometerButtonComponent from "./SpeedometerButton/SpeedometerButton";
import SpeechBubbleComponent from "./SpeechBubble/SpeechBubble";
import HeaderComponent from "./Header/Header";

export const SpeedoMeter = SpeedoMeterComponent;
export const SpeedometerButton = SpeedometerButtonComponent;
export const SpeechBubble = SpeechBubbleComponent;
export const Header = HeaderComponent;
